"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[9741],{

/***/ 90592:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": () => (/* binding */ linkToDispensePrescriptionANCWithParams),
/* harmony export */   "M_": () => (/* binding */ linkToDispensePrescriptionInpatientWithParams),
/* harmony export */   "ni": () => (/* binding */ linkToDispensePrescriptionOutpatientWithParams)
/* harmony export */ });
/* unused harmony exports PATIENT_PRESCRIPTIONS_SEGMENT, linkToPatientPrescriptions, linkToDispensePrescriptionOutpatient, linkToDispensePrescriptionInpatient, linkToDispensePrescriptionANC */
/* harmony import */ var elephant_web_client_patient_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90806);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28183);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


const appendSearch = (params) => {
  return (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(params, { addQueryPrefix: true });
};
const createQueryString = (opts) => {
  return appendSearch({
    locationId: opts.locationId,
    patientUuid: opts.patientUuid
  });
};
const PATIENT_PRESCRIPTIONS_SEGMENT = "prescriptions";
function linkToPatientPrescriptions() {
  return `${(0,elephant_web_client_patient_links__WEBPACK_IMPORTED_MODULE_0__/* .linkToPatient */ .i)()}/${PATIENT_PRESCRIPTIONS_SEGMENT}`;
}
function linkToDispensePrescriptionOutpatient() {
  return `${linkToPatientPrescriptions()}/outpatient`;
}
function linkToDispensePrescriptionInpatient() {
  return `${linkToPatientPrescriptions()}/inpatient`;
}
function linkToDispensePrescriptionANC() {
  return `${linkToPatientPrescriptions()}/anc`;
}
function linkToDispensePrescriptionANCWithParams(opts = {}) {
  return `${linkToDispensePrescriptionANC()}${createQueryString(opts)}`;
}
function linkToDispensePrescriptionInpatientWithParams(opts = {}) {
  return `${linkToDispensePrescriptionInpatient()}${createQueryString(opts)}`;
}
function linkToDispensePrescriptionOutpatientWithParams(opts = {}) {
  return `${linkToDispensePrescriptionOutpatient()}${createQueryString(opts)}`;
}


/***/ }),

/***/ 1961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ linkToCardReissue)
/* harmony export */ });
function linkToCardReissue() {
  return "/card/reissue";
}


/***/ }),

/***/ 73892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_mui_chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85810);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3047);




const CHIP_COLORS = {
  [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .PaymentStatus.Paid */ .bG.Paid]: "primary",
  [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .PaymentStatus.Unpaid */ .bG.Unpaid]: "warning"
};
const PaymentStatusChip = ({ status }) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const label = {
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .PaymentStatus.Paid */ .bG.Paid]: () => formatMessage({
      id: "patient.pay.registrationFeeStatus.paid",
      defaultMessage: "Paid"
    }),
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .PaymentStatus.Unpaid */ .bG.Unpaid]: () => formatMessage({
      id: "patient.pay.registrationFeeStatus.notPaid",
      defaultMessage: "Not Paid"
    })
  }[status]();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_chip__WEBPACK_IMPORTED_MODULE_1__/* .Chip */ .A, {
    label,
    color: CHIP_COLORS[status]
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PaymentStatusChip);


/***/ }),

/***/ 54873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ onTriageStatusForQueue)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77508);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18164);
/* harmony import */ var _queries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27047);
/* harmony import */ var _patient_triage_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37231);




function transformEvent(triageEvent, patient) {
  var _a, _b, _c, _d;
  if ("createdAt" in triageEvent) {
    return {
      _id: triageEvent.triageId,
      currentStatus: triageEvent.currentStatus,
      expiresAt: triageEvent.expiresAt,
      createdAt: triageEvent == null ? void 0 : triageEvent.createdAt,
      updatedAt: null,
      clinicUuid: triageEvent.clinicId,
      organisationUuid: null,
      patientUuid: triageEvent.patientId,
      __typename: "TriageStatusOfQueue"
    };
  }
  if ("updatedAt" in triageEvent && (!((_a = patient.triageStatus) == null ? void 0 : _a.updatedAt) || (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(
    new Date((_b = patient.triageStatus) == null ? void 0 : _b.updatedAt),
    new Date(triageEvent.updatedAt)
  ))) {
    return {
      _id: triageEvent.triageId,
      currentStatus: triageEvent.currentStatus,
      expiresAt: triageEvent.expiresAt,
      createdAt: (_d = (_c = patient.triageStatus) == null ? void 0 : _c.createdAt) != null ? _d : null,
      updatedAt: triageEvent.updatedAt,
      clinicUuid: triageEvent.clinicId,
      organisationUuid: null,
      patientUuid: triageEvent.patientId,
      __typename: "TriageStatusOfQueue"
    };
  }
  return null;
}
function onTriageStatusChanged(data, client) {
  var _a, _b, _c;
  const triageEvent = JSON.parse(data);
  const cachedQueues = (_b = (_a = client.readQuery({
    query: _queries__WEBPACK_IMPORTED_MODULE_0__/* .FACILITY_QUEUES */ .JT
  })) == null ? void 0 : _a.facilityQueues) != null ? _b : [];
  const queuedPatient = (_c = cachedQueues.find((queue) => {
    return queue.patients.find(
      (patient) => patient.uuid === triageEvent.patientId
    );
  })) == null ? void 0 : _c.patients.find((patient) => patient.uuid === triageEvent.patientId);
  if (queuedPatient) {
    const triageStatus = transformEvent(triageEvent, queuedPatient);
    if (!triageStatus) {
      return null;
    }
    const updatedPatient = {
      ...queuedPatient,
      triageStatus
    };
    const updatedQueues = (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(cachedQueues);
    const queueIndex = updatedQueues.findIndex((queue) => {
      return queue.patients.find(
        (patient) => patient.uuid === triageEvent.patientId
      );
    });
    const patientIndex = updatedQueues[queueIndex].patients.findIndex(
      (patient) => patient.uuid === triageEvent.patientId
    );
    const patients = updatedQueues[queueIndex].patients;
    patients[patientIndex] = updatedPatient;
    client.writeQuery({
      query: _queries__WEBPACK_IMPORTED_MODULE_0__/* .FACILITY_QUEUES */ .JT,
      data: { facilityQueues: updatedQueues }
    });
  }
  return null;
}
function onTriageStatusForQueue({ data, type }, client) {
  switch (type) {
    case _patient_triage_types__WEBPACK_IMPORTED_MODULE_1__/* .EventTypes.CREATED */ .G.CREATED:
    case _patient_triage_types__WEBPACK_IMPORTED_MODULE_1__/* .EventTypes.UPDATED */ .G.UPDATED:
      return onTriageStatusChanged(data, client);
    default:
      return null;
  }
}


/***/ }),

/***/ 44055:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": () => (/* binding */ linkToPatientRegister)
/* harmony export */ });
function linkToPatientRegister() {
  return "/patient-register";
}


/***/ }),

/***/ 22158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52018);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38384);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95061);



const getColorForTriageStatus = (colorKey, theme) => {
  if (!colorKey || colorKey === "none") {
    return theme.palette.figma.grey[200];
  }
  return theme.palette.figma[colorKey].main;
};
const TriageStatusBadge = ({
  color,
  size = 22,
  ...props
}) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    "aria-label": formatMessage(
      {
        id: "patientTriage.statusBadger.ariaLabel",
        defaultMessage: "Triage status {color}"
      },
      {
        color
      }
    ),
    flexShrink: 0,
    width: size,
    height: size,
    display: "inline-block",
    borderRadius: "50%",
    bgcolor: getColorForTriageStatus(color == null ? void 0 : color.toLowerCase(), theme),
    "data-testid": "TriageStatusBadge",
    ...props
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TriageStatusBadge);


/***/ }),

/***/ 91549:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ patient_triage_TriageStatusDropdown)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./src/client/api/endpoints.js
var endpoints = __webpack_require__(43750);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./src/client/patient-triage/useTriageStatus.tsx
var useTriageStatus = __webpack_require__(58011);
// EXTERNAL MODULE: ./src/client/patient-triage/__generated__/useTriageStatus.gql.ts
var useTriageStatus_gql = __webpack_require__(68);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/patient-triage/__generated__/useCreateTriageStatus.gql.ts



const defaultOptions = {};
const UseCreateTriageStatusDocument = graphql_tag_lib/* gql */.Ps`
    mutation UseCreateTriageStatus($input: CreatePatientTriageStatus!) {
  createPatientTriageStatus(input: $input) {
    ...PatientTriageStatus
    isInpatient
    isInAQueue
  }
}
    ${useTriageStatus_gql/* PatientTriageStatusFragmentDoc */.zu}`;
function useUseCreateTriageStatusMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UseCreateTriageStatusDocument, options);
}

;// CONCATENATED MODULE: ./src/client/patient-triage/useCreateTriageStatus.ts






const SUCCESS_MESSAGE = (0,lib/* defineMessage */.Em)({
  id: "patient-triage.status-update.success.msg",
  defaultMessage: "Success updating triage status"
});
const ERROR_MESSAGE = (0,lib/* defineMessage */.Em)({
  id: "patient-triage.status-update.error.msg",
  defaultMessage: "Failed to update triage status"
});
const CREATE_TRIAGE_STATUS = graphql_tag_lib/* gql */.Ps`
  mutation UseCreateTriageStatus($input: CreatePatientTriageStatus!) {
    createPatientTriageStatus(input: $input) {
      ...PatientTriageStatus
      isInpatient
      isInAQueue
    }
  }
  ${useTriageStatus/* PatientTriageStatusFragment */.J6}
`;
const handleTriageStatusCacheUpdate = (cache, variables, newStatus) => {
  cache.writeQuery(
    {
      query: useTriageStatus_gql/* PatientTriageStatusDocument */.l8,
      data: { patientTriageStatus: newStatus },
      variables
    }
  );
};
const useCreateTriageStatus = ({
  patientUuid,
  scheduleTriageExpiry
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return useUseCreateTriageStatusMutation({
    update: (cache, res) => {
      const {
        data: { createPatientTriageStatus }
      } = res;
      return handleTriageStatusCacheUpdate(
        cache,
        { input: { patientUuid } },
        createPatientTriageStatus
      );
    },
    onCompleted(data) {
      dist_default().success(formatMessage(SUCCESS_MESSAGE), {});
      scheduleTriageExpiry(data.createPatientTriageStatus);
    },
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    }
  });
};

;// CONCATENATED MODULE: ./src/client/patient-triage/__generated__/useUpdateTriageStatus.gql.ts



const useUpdateTriageStatus_gql_defaultOptions = {};
const UseUpdateTriageStatusDocument = graphql_tag_lib/* gql */.Ps`
    mutation UseUpdateTriageStatus($input: UpdatePatientTriageStatus!) {
  updatePatientTriageStatus(input: $input) {
    ...PatientTriageStatus
  }
}
    ${useTriageStatus_gql/* PatientTriageStatusFragmentDoc */.zu}`;
function useUseUpdateTriageStatusMutation(baseOptions) {
  const options = { ...useUpdateTriageStatus_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UseUpdateTriageStatusDocument, options);
}

;// CONCATENATED MODULE: ./src/client/patient-triage/useUpdateTriageStatus.ts






const UPDATE_TRIAGE_STATUS = graphql_tag_lib/* gql */.Ps`
  mutation UseUpdateTriageStatus($input: UpdatePatientTriageStatus!) {
    updatePatientTriageStatus(input: $input) {
      ...PatientTriageStatus
    }
  }
  ${useTriageStatus/* PatientTriageStatusFragment */.J6}
`;
const useUpdateTriageStatus = ({
  patientUuid,
  scheduleTriageExpiry
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return useUseUpdateTriageStatusMutation({
    update(cache, { data: { updatePatientTriageStatus } }) {
      return handleTriageStatusCacheUpdate(
        cache,
        { input: { patientUuid } },
        updatePatientTriageStatus
      );
    },
    onCompleted(data) {
      dist_default().success(formatMessage(SUCCESS_MESSAGE), {});
      scheduleTriageExpiry(data.updatePatientTriageStatus);
    },
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    }
  });
};

// EXTERNAL MODULE: ./src/client/patient-triage/TriageStatusBadge.tsx
var TriageStatusBadge = __webpack_require__(22158);
// EXTERNAL MODULE: ./src/client/apollo/RetryApolloContext.tsx
var RetryApolloContext = __webpack_require__(92560);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/patient-triage/__generated__/queries.gql.ts


const queries_gql_defaultOptions = {};
const TriageUseVisitDocument = graphql_tag_lib/* gql */.Ps`
    query TriageUseVisit($uuid: ID!, $uuString: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $uuString, searchWholeTerritory: $searchWholeTerritory) {
    passportId
    patient {
      uuid
      currentVisit {
        _id
        dischargeEvent {
          _id
          type
        }
        admissionEvent {
          _id
          type
        }
      }
    }
  }
  queueForPatient(input: {patientUuid: $uuid}) {
    _id
  }
}
    `;
function useTriageUseVisitQuery(baseOptions) {
  const options = { ...queries_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(TriageUseVisitDocument, options);
}
function useTriageUseVisitLazyQuery(baseOptions) {
  const options = { ...queries_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(TriageUseVisitDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/patient-triage/useInpatientVisitQuery.ts




const useInpatientVisitQuery = ({ patientUuid }, options) => {
  var _a;
  const territoryDataSharingFeatureEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const { data, loading } = useTriageUseVisitQuery({
    client: (0,RetryApolloContext/* useRetryApolloClient */.M)(),
    variables: {
      uuid: patientUuid,
      uuString: patientUuid,
      searchWholeTerritory: territoryDataSharingFeatureEnabled
    },
    ...options
  });
  const currentVisit = (_a = data == null ? void 0 : data.patientByCardId.patient) == null ? void 0 : _a.currentVisit;
  const normalizedData = (currentVisit == null ? void 0 : currentVisit.admissionEvent) && !(currentVisit == null ? void 0 : currentVisit.dischargeEvent) ? data : null;
  return {
    visitData: normalizedData,
    queueData: data == null ? void 0 : data.queueForPatient,
    loading
  };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(77508);
// EXTERNAL MODULE: ./src/client/patient-queue-management/events.triage.ts
var events_triage = __webpack_require__(54873);
// EXTERNAL MODULE: ./src/client/patient-triage/types.ts
var types = __webpack_require__(37231);
;// CONCATENATED MODULE: ./src/client/patient-triage/events.ts




function transformTriageStatusCreated(triageData) {
  return {
    _id: triageData.triageId,
    clinicUuid: triageData.clinicId,
    patientUuid: triageData.patientId,
    currentStatus: triageData.currentStatus,
    expiresAt: triageData.expiresAt,
    createdAt: triageData.createdAt,
    updatedAt: null,
    __typename: "TriageStatus"
  };
}
function transformTriageStatusUpdated(triageData) {
  return {
    _id: triageData.triageId,
    clinicUuid: triageData.clinicId,
    patientUuid: triageData.patientId,
    currentStatus: triageData.currentStatus,
    expiresAt: triageData.expiresAt,
    updatedAt: triageData.updatedAt,
    __typename: "TriageStatus"
  };
}
function readCachedTriage(client, patientUuid) {
  try {
    return client.readQuery({
      query: useTriageStatus/* TRIAGE_STATUS */.RC,
      variables: {
        input: {
          patientUuid
        }
      }
    });
  } catch (e) {
    return null;
  }
}
function onTriageStatusCreated(data, client) {
  try {
    const triageData = JSON.parse(data);
    const triage = transformTriageStatusCreated(triageData);
    const cached = readCachedTriage(client, triageData.patientId);
    if (!(cached == null ? void 0 : cached.patientTriageStatus)) {
      client.writeQuery({
        query: useTriageStatus/* TRIAGE_STATUS */.RC,
        variables: { input: { patientUuid: triageData.patientId } },
        data: { patientTriageStatus: triage },
        broadcast: true
      });
    }
    return triage;
  } catch {
  }
  return null;
}
function onTriageStatusUpdated(data, client) {
  try {
    const triageData = JSON.parse(data);
    const triage = transformTriageStatusUpdated(triageData);
    const cached = readCachedTriage(client, triageData.patientId);
    if (!(cached == null ? void 0 : cached.patientTriageStatus)) {
      client.writeQuery({
        query: useTriageStatus/* TRIAGE_STATUS */.RC,
        variables: { input: { patientUuid: triageData.patientId } },
        data: { patientTriageStatus: { ...triage, createdAt: null } },
        broadcast: true
      });
    }
    if (!cached.patientTriageStatus.updatedAt || (0,isBefore/* default */.Z)(
      new Date(cached.patientTriageStatus.updatedAt),
      new Date(triage.updatedAt)
    )) {
      client.writeQuery({
        query: useTriageStatus/* TRIAGE_STATUS */.RC,
        variables: { input: { patientUuid: triageData.patientId } },
        data: {
          patientTriageStatus: { ...cached.patientTriageStatus, ...triage }
        },
        broadcast: true
      });
    }
    return triage;
  } catch {
  }
  return null;
}
function onTriageStatus(event, client) {
  const { type, data } = event;
  let triage = null;
  switch (type) {
    case types/* EventTypes.CREATED */.G.CREATED:
      triage = onTriageStatusCreated(data, client);
      break;
    case types/* EventTypes.UPDATED */.G.UPDATED:
      triage = onTriageStatusUpdated(data, client);
      break;
    default:
      break;
  }
  (0,events_triage/* onTriageStatusForQueue */.o)(event, client);
  return triage;
}

// EXTERNAL MODULE: ./src/client/utils/handleEventsourceDisconnect.ts
var handleEventsourceDisconnect = __webpack_require__(72769);
// EXTERNAL MODULE: ./src/client/patient-triage/useScheduleTriageExpiry.tsx
var useScheduleTriageExpiry = __webpack_require__(95316);
// EXTERNAL MODULE: ./src/client/utils/useUserRole.ts
var useUserRole = __webpack_require__(67858);
// EXTERNAL MODULE: ./src/client/auth/SessionTokenProvider/SessionTokenProvider.tsx
var SessionTokenProvider = __webpack_require__(1767);
;// CONCATENATED MODULE: ./src/client/patient-triage/TriageStatusDropdown.tsx





















const getOptimisticTriageFixture = ({
  patientUuid
}) => ({
  _id: "optmistic-patient-triage-status-id",
  clinicUuid: "optmistic-patient-triage-status-clinicUuid",
  patientUuid,
  expiresAt: new Date(new Date().getTime() + 1e3 * 60).toISOString(),
  performer: {
    _id: "optmistic-patient-triage-status-performer-id",
    name: "optmistic-patient-triage-status-performer-name"
  },
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  organisationUuid: "optimistic-org-id",
  __typename: "TriageStatus"
});
const OPTIONS = [
  {
    value: base_gql/* TriageStatusType.Red */.lc.Red,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.red.label",
      defaultMessage: "Red"
    })
  },
  {
    value: base_gql/* TriageStatusType.Orange */.lc.Orange,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.orange.label",
      defaultMessage: "Orange"
    })
  },
  {
    value: base_gql/* TriageStatusType.Yellow */.lc.Yellow,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.yellow.label",
      defaultMessage: "Yellow"
    })
  },
  {
    value: base_gql/* TriageStatusType.Green */.lc.Green,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.green.label",
      defaultMessage: "Green"
    })
  },
  {
    value: base_gql/* TriageStatusType.Blue */.lc.Blue,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.blue.label",
      defaultMessage: "Blue"
    })
  },
  {
    value: base_gql/* TriageStatusType.None */.lc.None,
    label: (0,lib/* defineMessage */.Em)({
      id: "triageStatusDropdown.options.none.label",
      defaultMessage: "None"
    })
  }
];
const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  root: {
    backgroundColor: "transparent",
    height: "100%"
  },
  menuRoot: {
    padding: theme.spacing(2, 3)
  },
  icon: {
    color: theme.palette.secondary.main
  },
  optionInfo: {
    color: theme.palette.grey["600"],
    cursor: "text",
    fontSize: 12,
    paddingLeft: theme.spacing(2),
    pointerEvents: "none"
  }
}));
const userRoleCanEdit = [role_definitions_dist_module/* Role.DOCTOR */.uU.DOCTOR, role_definitions_dist_module/* Role.NURSE */.uU.NURSE, role_definitions_dist_module/* Role.TECHNICIAN */.uU.TECHNICIAN];
const clinicalSubscriptionServiceUrl = (0,endpoints/* default */.Z)().clinicalSubscriptionServicePath;
const TriageStatusDropdown = () => {
  var _a, _b, _c;
  const retryClient = (0,RetryApolloContext/* useRetryApolloClient */.M)();
  const classes = useStyles();
  const userRole = (0,useUserRole/* default */.Z)();
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  const isAuthorizedToEdit = react.useMemo(
    () => {
      var _a2;
      return (_a2 = (0,role_definitions_dist_module/* roleIsInRoles */.a3)(userRole, userRoleCanEdit)) != null ? _a2 : true;
    },
    [userRole]
  );
  const scheduleTriageExpiry = (0,useScheduleTriageExpiry/* useScheduleTriageExpiry */.y)();
  const {
    data: triageData,
    loading: statusLoading,
    refetch
  } = (0,useTriageStatus/* useTriageStatus */.lO)({
    patientUuid,
    scheduleTriageExpiry
  });
  const {
    visitData,
    queueData,
    loading: visitLoading
  } = useInpatientVisitQuery(
    { patientUuid },
    {
      skip: !isAuthorizedToEdit || !patientUuid
    }
  );
  const { sessionToken: token } = (0,SessionTokenProvider/* useSessionTokenContext */.ic)();
  react.useEffect(() => {
    if (!patientUuid) {
      return void 0;
    }
    const onMessage = (event) => {
      const triage = onTriageStatus(event, retryClient);
      if (triage) {
        scheduleTriageExpiry(triage);
      }
    };
    const triageEs = new EventSource(
      `${clinicalSubscriptionServiceUrl}events/triage?token=${token}&patientId=${patientUuid}`
    );
    triageEs.addEventListener(types/* EventTypes.CREATED */.G.CREATED, onMessage);
    triageEs.addEventListener(types/* EventTypes.UPDATED */.G.UPDATED, onMessage);
    (0,handleEventsourceDisconnect/* handleEventsourceDisconnect */.V)({
      es: triageEs,
      refetch,
      errorName: "EventSource.error.TriageStatusDropdown"
    });
    return () => {
      triageEs.close();
    };
  }, [patientUuid, refetch, retryClient, scheduleTriageExpiry, token]);
  const currentVisit = (_b = (_a = visitData == null ? void 0 : visitData.patientByCardId) == null ? void 0 : _a.patient) == null ? void 0 : _b.currentVisit;
  const triageStatus = triageData == null ? void 0 : triageData.patientTriageStatus;
  const triageStatusColor = (_c = triageStatus == null ? void 0 : triageStatus.currentStatus) != null ? _c : base_gql/* TriageStatusType.None */.lc.None;
  const currentQueue = queueData == null ? void 0 : queueData._id;
  const currentTriageIsNull = triageStatusColor === base_gql/* TriageStatusType.None */.lc.None;
  react.useEffect(() => {
    if (currentTriageIsNull)
      return;
    scheduleTriageExpiry(triageStatus);
  }, [triageStatus, currentTriageIsNull, scheduleTriageExpiry]);
  const [isUpdating, setIsUpdating] = react.useState(false);
  const [createStatus] = useCreateTriageStatus({
    patientUuid,
    scheduleTriageExpiry
  });
  const [updateStatus] = useUpdateTriageStatus({
    patientUuid,
    scheduleTriageExpiry
  });
  const handleUpdate = react.useCallback(
    async (triageStatusToUpdate) => {
      setIsUpdating(true);
      try {
        const isInpatient = !!currentVisit;
        const isInAQueue = !!currentQueue;
        if (currentTriageIsNull) {
          await createStatus({
            variables: {
              input: {
                patientUuid,
                triageStatus: triageStatusToUpdate,
                isInpatient,
                isInAQueue
              }
            },
            optimisticResponse: {
              createPatientTriageStatus: {
                ...getOptimisticTriageFixture({ patientUuid }),
                currentStatus: triageStatusToUpdate,
                isInpatient,
                isInAQueue
              }
            }
          });
        } else {
          await updateStatus({
            variables: {
              input: {
                triageStatusId: triageData == null ? void 0 : triageData.patientTriageStatus._id,
                newTriageStatus: triageStatusToUpdate
              }
            },
            optimisticResponse: {
              updatePatientTriageStatus: {
                ...triageData == null ? void 0 : triageData.patientTriageStatus,
                currentStatus: triageStatusToUpdate
              }
            }
          });
        }
      } finally {
        setIsUpdating(false);
      }
    },
    [
      currentTriageIsNull,
      createStatus,
      patientUuid,
      currentVisit,
      currentQueue,
      updateStatus,
      triageData == null ? void 0 : triageData.patientTriageStatus
    ]
  );
  if (!isAuthorizedToEdit) {
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      className: classes.root
    }, /* @__PURE__ */ react.createElement(TriageStatusBadge/* default */.Z, {
      color: triageStatusColor
    }));
  }
  return /* @__PURE__ */ react.createElement(mui_input_dist_module/* SelectField */.mg, {
    fullWidth: true,
    hideHelper: true,
    variant: "standard",
    disabled: isUpdating || visitLoading || statusLoading,
    name: "patient-triage-color",
    formControlProps: {
      className: classes.root
    },
    selectProps: {
      renderValue: (val) => /* @__PURE__ */ react.createElement(TriageStatusBadge/* default */.Z, {
        color: val
      }),
      value: triageStatusColor,
      onChange: (event) => {
        const newValue = event.target.value;
        handleUpdate(newValue);
      },
      className: classes.root,
      classes: {
        icon: classes.icon
      }
    }
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.optionInfo
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "triageStatusDropdown.options.info",
    defaultMessage: "Triage Color"
  }))), OPTIONS.map((opt) => {
    return /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
      classes: { root: classes.menuRoot },
      key: opt.value,
      value: opt.value
    }, /* @__PURE__ */ react.createElement(TriageStatusBadge/* default */.Z, {
      color: opt.value,
      mr: 1
    }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
      ...opt.label
    }));
  }));
};
/* harmony default export */ const patient_triage_TriageStatusDropdown = (TriageStatusDropdown);


/***/ }),

/***/ 32908:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ PatientCurrentVisitFragmentDoc)
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);

const PatientCurrentVisitFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment PatientCurrentVisit on Visit {
  _id
  expiryStrategy
  admissionEvent {
    _id
    type
  }
  detentionEvent {
    _id
    type
  }
  insuranceList {
    insurance {
      insuranceProvider {
        name
        insuranceType
        visitValidation {
          expiryStrategy
        }
      }
    }
    isValidForVisit
    visitInsuranceDetails
  }
}
    `;


/***/ }),

/***/ 87297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export currentVisitFragment */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);

const currentVisitFragment = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  fragment PatientCurrentVisit on Visit {
    _id
    expiryStrategy
    admissionEvent {
      _id
      type
    }
    detentionEvent {
      _id
      type
    }
    insuranceList {
      insurance {
        insuranceProvider {
          name
          insuranceType
          visitValidation {
            expiryStrategy
          }
        }
      }
      isValidForVisit
      visitInsuranceDetails
    }
  }
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  fragments: {
    currentVisit: currentVisitFragment
  }
});


/***/ }),

/***/ 47103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ patient)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/routes/RequireAuth.tsx
var RequireAuth = __webpack_require__(62205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./src/client/inpatient/InpatientRoutes.tsx
var InpatientRoutes = __webpack_require__(69411);
// EXTERNAL MODULE: ./src/client/components/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(60884);
// EXTERNAL MODULE: ./src/client/clinical-engine/diseases/useDiseases.tsx
var useDiseases = __webpack_require__(62604);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivitiesProvider.tsx
var InvestigationActivitiesProvider = __webpack_require__(85855);
// EXTERNAL MODULE: ./src/client/components/DynamicBreadcrumbs/DynamicBreadcrumbs.tsx
var DynamicBreadcrumbs = __webpack_require__(63592);
// EXTERNAL MODULE: ./src/client/routes/NavigateHome.tsx
var NavigateHome = __webpack_require__(55558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/client/components/HTMLControls/index.js + 10 modules
var HTMLControls = __webpack_require__(95803);
// EXTERNAL MODULE: ./src/client/investigations/RequestedCountBubble.tsx
var RequestedCountBubble = __webpack_require__(97270);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/patient/links.ts
var links = __webpack_require__(90806);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useCreateInvoice.ts + 1 modules
var useCreateInvoice = __webpack_require__(57202);
;// CONCATENATED MODULE: ./src/client/patient/pages/details/ActionsBar/CreateInvoiceButton.tsx








const CreateInvoiceButton = () => {
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  const { createInvoice } = (0,useCreateInvoice/* default */.Z)(patientUuid);
  const navigate = (0,react_router_dist/* useNavigate */.s0)();
  const createNewInvoice = (0,react.useCallback)(
    async (e) => {
      e.preventDefault();
      try {
        const { data } = await createInvoice();
        if (!data)
          return;
        navigate(
          (0,links/* linkToPatientDetails */.V)({
            patientUuid,
            invoiceId: data.createInvoice._id
          })
        );
      } catch (err) {
      }
    },
    [createInvoice, navigate, patientUuid]
  );
  return /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    "data-testid": "invoicing.create.newInvoice",
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.InvoiceIcon, null),
    size: "large",
    onClick: createNewInvoice
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.invoicingActions.create",
    defaultMessage: "Create Invoice"
  }));
};
/* harmony default export */ const ActionsBar_CreateInvoiceButton = (CreateInvoiceButton);

// EXTERNAL MODULE: ./src/client/pages/Prescriptions/links.ts
var Prescriptions_links = __webpack_require__(90592);
// EXTERNAL MODULE: ./src/client/investigations/links.ts
var investigations_links = __webpack_require__(73152);
// EXTERNAL MODULE: ./src/client/consultation/links.ts
var consultation_links = __webpack_require__(48325);
// EXTERNAL MODULE: ./src/client/antenatal-care/links.ts
var antenatal_care_links = __webpack_require__(11819);
// EXTERNAL MODULE: ./src/client/utils/useUserRole.ts
var useUserRole = __webpack_require__(67858);
;// CONCATENATED MODULE: ./src/client/routes/privateGuard.jsx


const privateGuard = (roles) => (Component) => (props) => {
  const userRole = (0,useUserRole/* default */.Z)();
  const isAuthorised = (0,react.useMemo)(
    () => {
      var _a;
      return (_a = roles == null ? void 0 : roles.includes(userRole)) != null ? _a : true;
    },
    [userRole]
  );
  if (isAuthorised) {
    return /* @__PURE__ */ react.createElement(Component, {
      ...props
    });
  }
  return null;
};
/* harmony default export */ const routes_privateGuard = (privateGuard);

;// CONCATENATED MODULE: ./src/client/patient/pages/details/ActionsBar/Action.tsx



const Action = ({ to, ...delegateProps }) => {
  const { search } = (0,react_router_dist/* useLocation */.TH)();
  const locationDesc = (0,react.useMemo)(() => {
    const searchParams = new URLSearchParams(search);
    if (typeof to === "string") {
      return {
        pathname: to,
        search: searchParams.toString()
      };
    }
    const newToParams = new URLSearchParams(to.search);
    newToParams.forEach((v, k) => {
      searchParams.append(k, v);
    });
    return {
      pathname: to.pathname,
      search: searchParams.toString()
    };
  }, [search, to]);
  return /* @__PURE__ */ react.createElement(mui_button_dist_module/* LinkButton */.Qj, {
    ...delegateProps,
    to: locationDesc
  });
};
/* harmony default export */ const ActionsBar_Action = (Action);

// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/useTracing.ts
var useTracing = __webpack_require__(13893);
// EXTERNAL MODULE: ./src/client/consultation/tracing.ts
var tracing = __webpack_require__(83523);
// EXTERNAL MODULE: ./src/client/components/GlobalAppIssueOverlay/SafetySpace.tsx
var SafetySpace = __webpack_require__(18747);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./src/client/investigations/tracing.ts
var investigations_tracing = __webpack_require__(475);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/patient/pages/details/ActionsBar/ActionsBar.tsx



















const DispenseDrugsButton = routes_privateGuard([
  dist_module/* Role.DOCTOR */.uU.DOCTOR,
  dist_module/* Role.ELEPHANT */.uU.ELEPHANT,
  dist_module/* Role.NURSE */.uU.NURSE,
  dist_module/* Role.PHARMACIST */.uU.PHARMACIST,
  dist_module/* Role.DISPENSER */.uU.DISPENSER
])(() => /* @__PURE__ */ react.createElement(ActionsBar_Action, {
  "data-testid": "Patient.DispenseDrugs",
  startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.PrescriptionIcon, null),
  color: "prescription",
  size: "large",
  to: (0,Prescriptions_links/* linkToDispensePrescriptionOutpatientWithParams */.ni)()
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patientDetails.dispenseBtn",
  defaultMessage: "Dispense"
})));
const CreateConsultationButton = routes_privateGuard([
  dist_module/* Role.ADMIN */.uU.ADMIN,
  dist_module/* Role.DOCTOR */.uU.DOCTOR,
  dist_module/* Role.ELEPHANT */.uU.ELEPHANT,
  dist_module/* Role.NURSE */.uU.NURSE,
  dist_module/* Role.ROOT */.uU.ROOT
])(() => {
  const { startSpan, addEventToSpan } = (0,useTracing/* useTracing */.k)();
  return /* @__PURE__ */ react.createElement(ActionsBar_Action, {
    "data-testid": "patientCreateConsultationBtn",
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.ConsultationIcon, null),
    color: "consultation",
    size: "large",
    to: (0,consultation_links/* linkToNewConsultation */.h)(),
    onClick: () => {
      startSpan(tracing/* NewConsultationTracingSpans.ROOT */.R.ROOT, { root: true });
      addEventToSpan(
        tracing/* NewConsultationTracingEvents */.P[tracing/* NewConsultationTracingSpans.ROOT */.R.ROOT].BEGIN
      );
    }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.newConsultationBtn",
    defaultMessage: "Consultation"
  }));
});
const AddInvestigationButton = routes_privateGuard([
  dist_module/* Role.DOCTOR */.uU.DOCTOR,
  dist_module/* Role.ELEPHANT */.uU.ELEPHANT,
  dist_module/* Role.NURSE */.uU.NURSE,
  dist_module/* Role.TECHNICIAN */.uU.TECHNICIAN
])(() => {
  const { startSpan, addEventToSpan } = (0,useTracing/* useTracing */.k)();
  return /* @__PURE__ */ react.createElement(ActionsBar_Action, {
    "data-testid": "patientAddInvestigationBtn",
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.InvestigationIcon, null),
    color: "investigation",
    size: "large",
    to: (0,investigations_links/* linkToPatientInvestigationsNew */.W)(),
    onClick: () => {
      startSpan(investigations_tracing/* NewInvestigationTracingSpans.ROOT */.s.ROOT, { root: true });
      addEventToSpan(
        investigations_tracing/* NewInvestigationTracingEvents */.M[investigations_tracing/* NewInvestigationTracingSpans.ROOT */.s.ROOT].BEGIN
      );
    }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patientDetails.addInvestigationBtn",
    defaultMessage: "Investigation"
  }));
});
const VitalsButton = routes_privateGuard([dist_module/* Role.DOCTOR */.uU.DOCTOR, dist_module/* Role.NURSE */.uU.NURSE])(() => /* @__PURE__ */ react.createElement(ActionsBar_Action, {
  "data-testid": "Patient.VitalsButton",
  startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.VitalsIcon, null),
  color: "vitals",
  size: "large",
  to: {
    pathname: (0,investigations_links/* linkToPatientInvestigationsNew */.W)(),
    search: "?investigation=vitals&investigationLoinc=85353-1"
  }
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patientDetails.vitalsBtn",
  defaultMessage: "Vitals"
})));
const AllergiesButton = routes_privateGuard([dist_module/* Role.DOCTOR */.uU.DOCTOR, dist_module/* Role.NURSE */.uU.NURSE])(() => /* @__PURE__ */ react.createElement(ActionsBar_Action, {
  "data-testid": "Patient.AllergiesButton",
  startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.AllergiesIcon, null),
  color: "allergies",
  size: "large",
  to: {
    pathname: (0,investigations_links/* linkToPatientInvestigationsNew */.W)(),
    search: "?investigation=allergy&investigationLoinc=95763-9"
  }
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patientDetails.allergiesBtn",
  defaultMessage: "Allergies"
})));
const RequestedInvestigationsBubble = routes_privateGuard([dist_module/* Role.TECHNICIAN */.uU.TECHNICIAN])(() => /* @__PURE__ */ react.createElement(RequestedCountBubble/* default */.Z, null));
const AntenatalCareButton = routes_privateGuard([dist_module/* Role.DOCTOR */.uU.DOCTOR, dist_module/* Role.NURSE */.uU.NURSE])(() => /* @__PURE__ */ react.createElement(ActionsBar_Action, {
  "data-testid": "Patient.AntenatalCareButton",
  startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.NewUserIcon, null),
  color: "vitals",
  size: "large",
  to: (0,antenatal_care_links/* linkToPatientCreateANC */.g)()
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "patientDetails.antenatalCareBtn",
  defaultMessage: "Antenatal Care"
})));
const GaplessGlobalAppIssueSafetySpace = (0,styled/* default */.Z)(SafetySpace/* default */.Z)(
  ({ theme }) => ({
    marginRight: -theme.spacing(1) - 8
  })
);
const ActionsBar = () => {
  const ancEnabled = (0,featureFlags/* useFeatureFlag */.ye)(featureFlags/* featureFlags.antenatalCare.actionButton */.VH.antenatalCare.actionButton);
  return /* @__PURE__ */ react.createElement(HTMLControls/* ButtonsBar */.t5, null, /* @__PURE__ */ react.createElement(GaplessGlobalAppIssueSafetySpace, null), /* @__PURE__ */ react.createElement(VitalsButton, null), /* @__PURE__ */ react.createElement(CreateConsultationButton, null), /* @__PURE__ */ react.createElement(AddInvestigationButton, null), /* @__PURE__ */ react.createElement(DispenseDrugsButton, null), /* @__PURE__ */ react.createElement(AllergiesButton, null), /* @__PURE__ */ react.createElement(ActionsBar_CreateInvoiceButton, null), ancEnabled && /* @__PURE__ */ react.createElement(AntenatalCareButton, null), /* @__PURE__ */ react.createElement(RequestedInvestigationsBubble, null));
};

;// CONCATENATED MODULE: ./src/client/patient/pages/details/ActionsBar/index.ts



// EXTERNAL MODULE: ./src/client/components/PatientOverview/BillingSidebar/index.tsx + 5 modules
var BillingSidebar = __webpack_require__(49666);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/index.tsx
var PatientOverview = __webpack_require__(9559);
;// CONCATENATED MODULE: ./src/client/patient/pages/details/PatientDetailsPage.tsx









const PatientDetailsPage = () => {
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  if (!patientUuid) {
    dist_default().error("No user selected.");
    return /* @__PURE__ */ react.createElement(NavigateHome/* default */.Z, null);
  }
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(HTMLControls/* PageColumns */.gC, {
    dataTestId: "patientDetailsPageContainer",
    mainContent: /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(DynamicBreadcrumbs/* DynamicBreadcrumbs */.V, null), /* @__PURE__ */ react.createElement(PatientOverview/* default */.Z, {
      patientUuid
    })),
    sidebar: /* @__PURE__ */ react.createElement(BillingSidebar/* default */.Z, {
      patientUuid
    })
  }), /* @__PURE__ */ react.createElement(ActionsBar, null));
};
/* harmony default export */ const details_PatientDetailsPage = (PatientDetailsPage);

;// CONCATENATED MODULE: ./src/client/patient/pages/details/index.ts

/* harmony default export */ const details = (details_PatientDetailsPage);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(43217);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/client/components/Layout/Body.tsx
var Body = __webpack_require__(99589);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/PatientDetailsHeader/index.tsx + 8 modules
var PatientDetailsHeader = __webpack_require__(39158);
;// CONCATENATED MODULE: ./src/client/patient/PatientDetailsLayout.tsx








const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)(() => ({
  headerContentOffset: {
    minHeight: "60px"
  }
}));
const PatientDetailsLayout = ({
  children = /* @__PURE__ */ react.createElement(react_router_dist/* Outlet */.j3, null)
}) => {
  const classes = useStyles();
  const smallWidthDevice = (0,useMediaQuery/* default */.Z)(constants/* MEDIA_QUERY_SMALL_DEVICE */.tX);
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, smallWidthDevice ? /* @__PURE__ */ react.createElement("div", {
    className: classes.headerContentOffset
  }) : null, /* @__PURE__ */ react.createElement(PatientDetailsHeader/* default */.Z, null), /* @__PURE__ */ react.createElement(Body/* default */.Z, {
    mainContent: children
  }));
};
/* harmony default export */ const patient_PatientDetailsLayout = (PatientDetailsLayout);

// EXTERNAL MODULE: ./src/client/common/PatientProvider.ts
var PatientProvider = __webpack_require__(51971);
// EXTERNAL MODULE: ./src/client/antenatal-care/AntenatalCarePage.tsx + 18 modules
var AntenatalCarePage = __webpack_require__(47871);
// EXTERNAL MODULE: ./src/client/inpatient/links.ts
var inpatient_links = __webpack_require__(2360);
;// CONCATENATED MODULE: ./src/client/patient/index.tsx














const PrescriptionsPage = (0,react.lazy)(
  () => Promise.all(/* import() | Prescriptions */[__webpack_require__.e(824), __webpack_require__.e(7855), __webpack_require__.e(1610)]).then(__webpack_require__.bind(__webpack_require__, 87079))
);
const NewInvestigationPage = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | NewInvestigation */ 9896).then(__webpack_require__.bind(__webpack_require__, 79532))
);
const ConsultationRoutes = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | Consultation */ 8221).then(__webpack_require__.bind(__webpack_require__, 8664))
);
const { DOCTOR, ELEPHANT, NURSE, TECHNICIAN, PHARMACIST, DISPENSER } = dist_module/* Role */.uU;
const PatientRoutes = () => {
  const query = (0,useQuerystring/* default */.Z)();
  const uuid = query.patientUuid || query.patient;
  return /* @__PURE__ */ react.createElement(ErrorBoundary/* default */.Z, {
    name: "patient-routes"
  }, /* @__PURE__ */ react.createElement(PatientProvider/* PatientContext.Provider */.a.Provider, {
    value: { uuid }
  }, /* @__PURE__ */ react.createElement(InvestigationActivitiesProvider/* default */.ZP, null, /* @__PURE__ */ react.createElement(react_router_dist/* Routes */.Z5, null, /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    element: /* @__PURE__ */ react.createElement(patient_PatientDetailsLayout, null)
  }, /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "details",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      except: [dist_module/* Role.ROOT */.uU.ROOT]
    }, /* @__PURE__ */ react.createElement(details, null))
  }), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "prescriptions/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [DOCTOR, ELEPHANT, NURSE, PHARMACIST, DISPENSER]
    }, /* @__PURE__ */ react.createElement(PrescriptionsPage, null))
  }), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "consultations/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: useDiseases/* CREATE_CONSULTATION_ROLES */.m
    }, /* @__PURE__ */ react.createElement(ConsultationRoutes, null))
  }), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "inpatient/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: inpatient_links/* INPATIENT_AUTHORISED_ROLES */.Pp
    }, /* @__PURE__ */ react.createElement(InpatientRoutes/* default */.Z, null))
  }), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "investigations"
  }, /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "new",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [DOCTOR, ELEPHANT, NURSE, TECHNICIAN]
    }, /* @__PURE__ */ react.createElement(NewInvestigationPage, null))
  })), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "create-anc",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [DOCTOR, NURSE]
    }, /* @__PURE__ */ react.createElement(AntenatalCarePage/* AntenatalCarePage */.q, null))
  }), /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: "anc"
  }, /* @__PURE__ */ react.createElement(react_router_dist/* Route */.AW, {
    path: ":encounterId",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [DOCTOR, NURSE]
    }, /* @__PURE__ */ react.createElement(AntenatalCarePage/* AntenatalCarePage */.q, null))
  })))))));
};
/* harmony default export */ const patient = (PatientRoutes);


/***/ }),

/***/ 57081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61800);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12850);
/* harmony import */ var _components_Dose_StyledDosageString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98605);




const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((theme) => ({
  columnWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: 4,
    overflowWrap: "break-word"
  },
  instructionWrapper: {
    marginTop: 2,
    boxShadow: `0 -1.5px ${theme.palette.grey[600]}`,
    paddingBlock: "4mm"
  },
  title: {
    ...theme.typography.subtitle1,
    fontSize: "4mm",
    fontWeight: 700,
    marginBottom: "1mm"
  },
  subtitle: {
    ...theme.typography.subtitle2,
    fontSize: "3.5mm",
    color: theme.palette.grey[600],
    lineHeight: 1.5,
    fontWeight: 700
  },
  adjacentText: {
    display: "inline",
    marginLeft: 4
  },
  text: { ...theme.typography.body2, fontSize: "3.5mm", lineHeight: 1.5 },
  instructionDetails: {
    display: "flex",
    flexDirection: "column",
    gap: 4
  },
  instructionLine: {
    display: "flex",
    gap: 8
  }
}));
const Instruction = ({
  title,
  prescribedAt,
  notes,
  dose
}) => {
  const styles = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.title
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: styles.instructionDetails
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: styles.instructionLine
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.subtitle
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "prescriptions.printableInstructions.datePrescribed",
    defaultMessage: "Date prescribed"
  }), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "body2"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "prescriptions.printableInstructions.datePrescribedValue",
    defaultMessage: "{prescribedAt, date, short}",
    values: {
      prescribedAt
    }
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: styles.instructionLine
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.subtitle
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "prescriptions.printableInstructions.taken",
    defaultMessage: "Taken"
  }), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.text
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Dose_StyledDosageString__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    ...dose
  }))), notes && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.subtitle
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "prescriptions.printableInstructions.notes",
    defaultMessage: "Notes"
  }), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.text
  }, notes))));
};
const PrescriptionInstructions = ({ instructions, patientName, facilityName }) => {
  const styles = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: styles.columnWrapper
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.title
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    id: "prescriptions.printableInstructions.header",
    defaultMessage: "Prescription instructions for {patientName}",
    values: { patientName }
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: styles.text
  }, facilityName), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, instructions.map((instruction) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    key: instruction.id,
    className: styles.instructionWrapper
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Instruction, {
    ...instruction
  }))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PrescriptionInstructions);


/***/ }),

/***/ 87502:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

const ThermalPrintableArea = ({ printableRef, children }) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    "data-testid": "printableAreaWrapper",
    style: {
      opacity: "0%",
      pointerEvents: "none",
      zIndex: 999999,
      position: "absolute",
      top: "30px",
      right: "30px",
      overflow: "hidden"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: printableRef,
    style: {
      backgroundColor: "white",
      width: "70mm"
    }
  }, children));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ThermalPrintableArea);


/***/ }),

/***/ 73837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var html_to_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49480);
/* harmony import */ var escpos_buffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46721);
/* harmony import */ var escpos_buffer__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(escpos_buffer__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useThermalPrinter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67891);
/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];




const useThermalPrintDivAsImage = () => {
  const printableRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const { print: thermalPrint, error: printerError } = (0,_useThermalPrinter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!printerError) {
      return;
    }
    setError(printerError);
  }, [printerError]);
  const printImage = async (printer) => {
    try {
      const dataUrl = await (0,html_to_image__WEBPACK_IMPORTED_MODULE_1__/* .toPng */ .YM)(printableRef.current, { cacheBust: true });
      const b64Png = dataUrl.split(",")[1];
      const buffer = Buffer.from(b64Png, "base64");
      const image = new escpos_buffer__WEBPACK_IMPORTED_MODULE_2__.Image(buffer, new escpos_buffer__WEBPACK_IMPORTED_MODULE_2__.BayerOrdered());
      await printer.draw(image);
      await printer.feed(4);
      await printer.cutter();
    } catch (err) {
      setError(err);
    }
  };
  return {
    print: () => thermalPrint(printImage),
    printableRef,
    error
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useThermalPrintDivAsImage);


/***/ }),

/***/ 47274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ formatCardId),
/* harmony export */   "s": () => (/* binding */ getCardId)
/* harmony export */ });
const getCardId = (data) => {
  var _a;
  if (!((_a = data == null ? void 0 : data.patientByCardId) == null ? void 0 : _a.patient)) {
    return void 0;
  }
  const { patient, passportId } = data.patientByCardId;
  return patient.cardId ? patient.cardId : passportId;
};
const NA = "-";
function formatCardId(cardId) {
  if (!cardId) {
    return NA;
  }
  return `${cardId.substr(0, 4)} ${cardId.substr(4, 4)} ${cardId.substr(8, 4)}`;
}


/***/ }),

/***/ 9921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ dateYearsMonths),
/* harmony export */   "o": () => (/* binding */ removeTypename)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87201);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54033);

const dateYearsMonths = (date, today = new Date()) => {
  const years = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(today, date);
  let output = "";
  let suffix = "";
  if (years < 3) {
    output += (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(today, date);
    suffix = "m";
  } else {
    output += years;
  }
  if (Number.isNaN(Number(output))) {
    return "";
  }
  return `${output}${suffix}`;
};
const removeTypename = (raw) => {
  const result = Object.keys(raw).filter((key) => !["__typename"].includes(key)).reduce((object, key) => {
    object[key] = raw[key];
    return object;
  }, {});
  return result;
};


/***/ }),

/***/ 61267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ PRESCRIPTION_STATES),
/* harmony export */   "P": () => (/* binding */ getPrescriptionDispensationState)
/* harmony export */ });
const PRESCRIPTION_STATES = {
  AWAITING_DISPENSE: "ready_to_dispense",
  EXPIRED: "expired",
  DISPENSED: "dispensed",
  PAPER_PRESCRIPTION_ISSUED: "paper_prescription_issued",
  NA: "N/A"
};
const getPrescriptionDispensationState = (prescription) => {
  if (!prescription || !prescription.dispensation) {
    return PRESCRIPTION_STATES.NA;
  }
  if (prescription.dispensation.status === PRESCRIPTION_STATES.PAPER_PRESCRIPTION_ISSUED) {
    return PRESCRIPTION_STATES.PAPER_PRESCRIPTION_ISSUED;
  }
  if (prescription.dispensation.status === PRESCRIPTION_STATES.DISPENSED) {
    return PRESCRIPTION_STATES.DISPENSED;
  }
  if (prescription.dispensation.status === PRESCRIPTION_STATES.EXPIRED || prescription.dispensation.status === PRESCRIPTION_STATES.AWAITING_DISPENSE && Date.now() > new Date(prescription.dispensation.validityPeriod)) {
    return PRESCRIPTION_STATES.EXPIRED;
  }
  if (prescription.dispensation.status === PRESCRIPTION_STATES.AWAITING_DISPENSE) {
    return PRESCRIPTION_STATES.AWAITING_DISPENSE;
  }
  return PRESCRIPTION_STATES.NA;
};


/***/ }),

/***/ 43566:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useEvictCacheOnUnmount)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79226);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15401);



function useEvictCacheOnUnmount(opts) {
  const apollo = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useApolloClient */ .x)();
  const optsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(opts);
  if (!(0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(optsRef.current, opts)) {
    optsRef.current = opts;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const optsClone = { ...optsRef.current };
    return () => {
      apollo.cache.evict(optsClone);
      apollo.cache.gc();
    };
  }, [apollo, optsRef.current]);
}


/***/ }),

/***/ 5353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11313);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5981);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6754);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20589);




const genderMap = {
  [_constants__WEBPACK_IMPORTED_MODULE_1__/* .GENDER_CODES.MALE */ .tE.MALE]: (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
    id: "userGender.male",
    defaultMessage: "Male"
  }),
  [_constants__WEBPACK_IMPORTED_MODULE_1__/* .GENDER_CODES.FEMALE */ .tE.FEMALE]: (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
    id: "userGender.female",
    defaultMessage: "Female"
  })
};
const genderUnknownMessage = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
  id: "userGender.unknown",
  defaultMessage: "Unknown"
});
const useGenderTranslation = () => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const translateGenderCode = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(
    (genderCode) => formatMessage(genderMap[genderCode] || genderUnknownMessage),
    [formatMessage]
  );
  const genders = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("name"))(
      Object.values(_constants__WEBPACK_IMPORTED_MODULE_1__/* .GENDER_CODES */ .tE).map((code) => ({
        name: translateGenderCode(code),
        code
      }))
    ),
    [translateGenderCode]
  );
  return { genders, translateGenderCode };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useGenderTranslation);


/***/ }),

/***/ 31790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97754);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61800);



const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  root: {
    whiteSpace: "pre-line"
  }
});
const MultiLineTypography = ({
  className,
  ...props
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(classes.root, className),
    ...props
  });
};
MultiLineTypography.defaultProps = {
  component: void 0
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiLineTypography);


/***/ })

}]);